(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-labels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-product-labels')) {
    class CollectionProductLabels extends HTMLElement {
      connectedCallback() {
        this.applyLabels();

        this.observer = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
            this.applyLabels();
          }
        });

        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.querySelectorAll(`[data-collection-label-owner="${this.id}"]`).forEach((label) => label.remove());
      }

      applyLabels() {
        const rules = Array.from(this.querySelectorAll('[data-collection-label-rule]'));
        if (!rules.length) return;

        document.querySelectorAll('.product-block[data-product-collections]').forEach((card) => {
          const wrapper = card.querySelector('.image-label-wrap');
          if (!wrapper) return;

          wrapper.style.position = 'relative';

          const collectionHandles = card.dataset.productCollections.trim().split(/\s+/);

          rules.forEach((rule, ruleIndex) => {
            if (!collectionHandles.includes(rule.dataset.collectionHandle)) return;

            const labelKey = `${this.id}-${ruleIndex}`;
            if (wrapper.querySelector(`[data-collection-label-key="${labelKey}"]`)) return;

            const position = rule.dataset.position;
            let slot = wrapper.querySelector(`[data-collection-label-slot="${position}"][data-collection-label-owner="${this.id}"]`);

            if (!slot) {
              slot = document.createElement('div');
              slot.className = `collection-product-labels__slot collection-product-labels__slot--${position}`;
              Object.assign(slot.style, {
                position: 'absolute',
                top: position.startsWith('top') ? '10px' : 'auto',
                right: position.endsWith('right') ? '10px' : 'auto',
                bottom: position.startsWith('bottom') ? '10px' : 'auto',
                left: position.endsWith('left') ? '10px' : 'auto',
                zIndex: '4'
              });
              slot.dataset.collectionLabelSlot = position;
              slot.dataset.collectionLabelOwner = this.id;
              wrapper.appendChild(slot);
            }

            const label = document.createElement('span');
            label.className = 'collection-product-labels__label';
            label.dataset.collectionLabelKey = labelKey;
            label.style.cssText = rule.style.cssText;

            const contentType = rule.dataset.contentType;
            const showImage = contentType !== 'text' && rule.dataset.imageUrl;
            const showText = contentType !== 'image' && rule.dataset.labelText;

            if (!showImage && !showText) return;

            if (showImage) {
              const image = document.createElement('img');
              image.className = 'collection-product-labels__image';
              image.src = rule.dataset.imageUrl;
              image.alt = rule.dataset.imageAlt || '';
              image.loading = 'lazy';
              image.width = Number(rule.dataset.imageWidth);
              image.style.setProperty('--collection-label-image-width', `${rule.dataset.imageWidth}px`);
              label.appendChild(image);
            }

            if (showText) {
              const text = document.createElement('span');
              text.textContent = rule.dataset.labelText;
              label.appendChild(text);
            }

            if (showImage && !showText) label.classList.add('collection-product-labels__label--image-only');
            slot.appendChild(label);
          });
        });
      }
    }

    customElements.define('collection-product-labels', CollectionProductLabels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
